export default __webpack_public_path__ + "static/media/service_image.117d968a.svg";